<template>
<div class="vx-row">
    <div class="vx-col w-full">
        <vx-card fixed-height="true">
            <div v-if="menu == 0">
                <!-- FILA 1: Filtro principal (backend) -->
                <div class="despachos-filtros-panel">
                    <div class="filtros-row">
                        <vs-button
                            color="primary"
                            type="filled"
                            icon="refresh"
                            size="small"
                            @click="cargarVentasPerseo()"
                        >
                            <i class="fa-solid fa-sync-alt mr-1"></i> Recargar
                        </vs-button>

                        <div class="filtros-separador"></div>

                        <div class="filtros-grupo">
                            <span class="filtros-etiqueta">Estado:</span>
                            <div class="filtros-estado-btns">
                                <button
                                    :class="['estado-btn', filtroEstado === 'todos' ? 'estado-btn-activo estado-btn-todos' : '']"
                                    @click="filtroEstado = 'todos'; cargarVentasPerseo()"
                                >Todos</button>
                                <button
                                    :class="['estado-btn', filtroEstado === '2' ? 'estado-btn-activo estado-btn-pendiente' : '']"
                                    @click="filtroEstado = '2'; cargarVentasPerseo()"
                                >Pendientes</button>
                                <button
                                    :class="['estado-btn', filtroEstado === '1' ? 'estado-btn-activo estado-btn-despachado' : '']"
                                    @click="filtroEstado = '1'; cargarVentasPerseo()"
                                >Despachadas</button>
                            </div>
                        </div>

                        <!-- Resumen inline -->
                        <template v-if="resumenVentas">
                            <div class="filtros-separador"></div>
                            <div class="resumen-item resumen-total">
                                <i class="fa-solid fa-list-ol"></i>
                                <span>Total: <b>{{ resumenVentas.total }}</b></span>
                            </div>
                            <div class="resumen-item resumen-pendientes">
                                <i class="fa-solid fa-clock"></i>
                                <span>Pendientes: <b>{{ resumenVentas.pendientes }}</b></span>
                            </div>
                            <div class="resumen-item resumen-despachadas">
                                <i class="fa-solid fa-check-circle"></i>
                                <span>Despachadas: <b>{{ resumenVentas.despachadas }}</b></span>
                            </div>
                        </template>
                    </div>
                </div>

                <!-- FILA 2: Filtro de fechas (backend) -->
                <div class="despachos-filtros-fechas">
                    <div class="filtros-row">
                        <button
                            :class="['filtros-fechas-toggle', filtroFechasActivo ? 'filtros-fechas-toggle-activo' : '']"
                            @click="filtroFechasActivo = !filtroFechasActivo"
                        >
                            <i class="fa-solid fa-calendar-days mr-1"></i>
                            {{ filtroFechasActivo ? 'Filtro por Fecha ✓' : 'Filtrar por Fechas' }}
                        </button>

                        <template v-if="filtroFechasActivo">
                            <div class="filtros-separador"></div>

                            <div class="filtros-grupo">
                                <span class="filtros-etiqueta">Desde:</span>
                                <input type="date" v-model="fechaDesde" class="filtros-input-fecha">
                            </div>
                            <div class="filtros-grupo">
                                <span class="filtros-etiqueta">Hasta:</span>
                                <input type="date" v-model="fechaHasta" class="filtros-input-fecha">
                            </div>

                            <div class="filtros-separador"></div>

                            <div class="filtros-grupo" v-if="userRoot || userFacturador || userAdminFacturador">
                                <span class="filtros-etiqueta">Origen:</span>
                                <div class="filtros-radio-group">
                                    <label class="filtros-radio-label">
                                        <input type="radio" v-model="soloEnviadoPerseo" :value="1" class="filtros-radio" @change="cargarVentasPerseo()">
                                        <span>Solo Perseo</span>
                                    </label>
                                    <label class="filtros-radio-label">
                                        <input type="radio" v-model="soloEnviadoPerseo" :value="0" class="filtros-radio" @change="cargarVentasPerseo()">
                                        <span>Todos</span>
                                    </label>
                                </div>
                            </div>

                            <vs-button
                                color="primary"
                                type="border"
                                size="small"
                                @click="filtrarPorFecha()"
                                title="Consultar al servidor con las fechas seleccionadas"
                            >
                                <i class="fa-solid fa-search mr-1"></i> Consultar
                            </vs-button>
                            <vs-button
                                color="danger"
                                type="flat"
                                size="small"
                                @click="limpiarFiltroFechas()"
                                title="Quitar filtro de fechas y recargar todo"
                            >
                                <i class="fa-solid fa-times mr-1"></i> Quitar filtro
                            </vs-button>
                        </template>
                    </div>
                </div>
                <perseo-tabla-avanzada
                    :datos="ventasFiltradas"
                    :columnas="columnasTabla"
                    :mostrar-acciones="true"
                    :items-por-pagina-inicial="25"
                >
                    <template #column-ven_codigo="{ row }">
                        <div class="py-2">
                            <div class="font-bold text-primary">{{ row.ven_codigo }}</div>
                            <div class="text-xs text-gray-600 mt-1">
                                <vx-tooltip :text="`Empresa: ${row.empresa || 'N/A'}`" position="left">
                                    <i class="fa-solid fa-building"></i> {{ row.empresa || 'N/A' }}
                                </vx-tooltip>
                            </div>
                            <div v-if="row.contrato" class="text-xs text-gray-600 mt-1">
                                <vx-tooltip :text="`Contrato: ${row.contrato}`" position="left">
                                     <i class="fa-solid fa-file-contract"></i> {{ row.contrato }}
                                </vx-tooltip>
                            </div>
                            <div v-if="row.nombre_facturador" class="text-xs text-gray-600 mt-1">
                                <vx-tooltip :text="`Facturador: ${row.nombre_facturador}`" position="left">
                                     <i class="fa-solid fa-user"></i> {{ row.nombre_facturador }}
                                </vx-tooltip>
                            </div>
                            <div class="text-xs text-gray-600 mt-1">
                                <vx-tooltip :text="`Fecha de venta: ${fechaCorta(row.ven_fecha)}`" position="left">
                                     <i class="fa-solid fa-calendar-days"></i> {{ fechaCorta(row.ven_fecha) }}
                                </vx-tooltip>
                            </div>
                        </div>
                    </template>

                    <template #column-ven_cliente="{ row }">
                        <div class="py-2">
                            <div class="font-semibold">{{ row.nombre_cliente || 'Sin cliente' }}</div>
                            <div v-if="row.asesor_guia" class="text-xs text-gray-600 mt-1">
                              <vx-tooltip text="Asesor de guía" position="left">
                                <i class="fa-solid fa-user"></i> Asesor: {{ row.asesor_guia }}
                              </vx-tooltip>
                            </div>
                            <div v-if="row.nombreInstitucion" class="text-xs text-gray-600 mt-1">
                                <vx-tooltip text="Lugar de despacho" position="left">
                                    <i class="fa-solid fa-school"></i> {{ row.nombreInstitucion }}
                                </vx-tooltip>
                            </div>
                            <div v-if="row.periodoescolar" class="text-xs text-gray-600 mt-1">
                                <vx-tooltip text="Periodo escolar" position="left">
                                    <i class="fa-solid fa-calendar-days"></i> {{ row.periodoescolar }}
                                </vx-tooltip>
                            </div>
                        </div>
                    </template>

                    <template #column-estado_nombre="{ row }">
                        <div class="py-2">
                            {{row.tipo_venta}}
                            <vs-chip
                                :color="row.est_ven_codigo == 1 ? 'success' : row.est_ven_codigo == 2 ? 'warning' : 'danger'"
                            >
                                {{ row.estado_nombre }}
                            </vs-chip>
                        </div>
                    </template>

                    <!-- <template #column-ven_fecha="{ row }">
                        <div class="py-2">
                            <div class="text-sm">
                                <i class="fa-solid fa-calendar"></i>
                                {{ fechaCorta(row.ven_fecha) }}
                            </div>
                        </div>
                    </template> -->

                    <template #column-factura_perseo="{ row }">
                        <div class="py-2">
                            <div v-if="row.pedido_codigo" class="text-xs text-gray-600 mt-1">
                                <vx-tooltip text="Pedido Perseo" position="left">
                                    <i class="fa-regular fa-file"></i> {{ row.pedido_codigo }}
                                </vx-tooltip>
                            </div>
                            <div v-if="row.factura_perseo">
                                <vs-chip color="success" class="font-semibold">
                                    <i class="fa-solid fa-file-invoice"></i>
                                    {{ row.factura_perseo }}
                                </vs-chip>
                                <!-- <div v-if="row.id_factura_perseo" class="text-xs text-gray-600 mt-1">
                                    ID: {{ row.id_factura_perseo }}
                                </div> -->
                            </div>
                            <div v-else-if="row.estadoPerseo == 1">
                                <vs-chip color="warning">
                                    <i class="fa-solid fa-clock"></i>
                                    Pendiente
                                </vs-chip>
                            </div>
                            <div v-else>
                                <span class="text-xs text-gray-500">-</span>
                            </div>
                        </div>
                    </template>

                    <template #acciones="{ row }">
                        <div class="flex gap-2 justify-center">
                            <vs-button
                                size="small"
                                color="primary"
                                type="border"
                                @click="ObjectedSelected=row; verPDFVenta(row)"
                                title="Imprimir"
                            >
                                <i class="fa-solid fa-print"></i>
                            </vs-button>
                            <vs-button
                                v-if="(row.est_ven_codigo == 2 && row.estadoPerseo == 1 && !row.factura_perseo) && !userFacturador && !userAdminFacturador"
                                size="small"
                                color="warning"
                                type="border"
                                @click="ObjectedSelected=row; verificarPedidoPerseo(row)"
                                title="Verificar en Perseo"
                            >
                                <i class="fa-solid fa-search"></i>
                            </vs-button>
                            <vs-button
                                v-if="(row.est_ven_codigo == 2 && ((row.estadoPerseo == 1 && row.factura_perseo) || row.estadoPerseo != 1)) && !userFacturador && !userAdminFacturador"
                                size="small"
                                color="success"
                                type="filled"
                                @click="ObjectedSelected=row; marcarComoDespachadoPerseo(row)"
                                title="Marcar como Despachado"
                            >
                                <i class="fa-solid fa-truck"></i> Despachar
                            </vs-button>
                        </div>
                    </template>
                </perseo-tabla-avanzada>
            </div>
            <!--CREAR EMPAQUE-->
            <div v-if="menu == 1">
                <vs-button type="line" class="mt-2" @click="menu = 0;">← Regresar</vs-button>
                <EmpacarCrearVue :opcion="opcion" :ObjectedDocument="ObjectedSelected" :id="id" @changen="changen" />
            </div>
            <!--modales-->
            <!-- DOCUMENTO IMPRESION PDF -->
            <vs-popup-history
                v-if="popupPDFVenta"
                fullscreen
                class="popup-pdf-venta"
                :title="`Documento ${ventaSeleccionadaPDF.ven_codigo || ''}`"
                :active.sync="popupPDFVenta"
            >
                <ReporteVentasPDF
                    v-if="ventaSeleccionadaPDF"
                    :venta="ventaSeleccionadaPDF"
                />
            </vs-popup-history>
        </vx-card>
        <!--modal para despachar-->
        <vs-popup class="despachar" :title="`Confirmar Despacho`" :active.sync="popupDespachar">
          <div v-if="popupDespachar">
            <p class="text-2xl text-center">¿Está seguro de despachar la venta <b>{{ ObjectedSelected.ven_codigo }}</b>?</p>
          </div>
          <br>
          <div class="flex justify-center mt-1">
            <vs-button class="mr-5" @click="f_despachar(); popupDespachar=false" type="relief">Aceptar</vs-button>
            <vs-button @click="popupDespachar=false" color="warning" type="relief">Cancelar</vs-button>
          </div>
        </vs-popup>
        <!--modal para mover a pendiente-->
        <vs-popup class="informacionformhijo" :title="`Regresar a Pendiente`" :active.sync="popupRegresarAPendiente">
            <div v-if="popupRegresarAPendiente">
                <p class="text-center">Regresar a pendiente documento: <b>{{ ObjectedSelected.ven_codigo }}</b></p>
                <br>
                <RegresarAPendiente :datadocumento="ObjectedSelected" @change="changePendiente" />
            </div>
        </vs-popup>
        <!--MODAL PARA EDITAR EMPACADO-->
        <vs-popup fullscreen  :active.sync="popupAbrirEmpacadoEditar" title="Editar" class="popopPadre">
            <div v-if="popupAbrirEmpacadoEditar">
                <EmpacarEditVue :ObjectedDocument="ObjectedDocument" :id="ObjectedSelected.ven_codigo" @cerrar="change" />
            </div>
        </vs-popup>
        <!--MODAL PARA INGRESAR GUIA-->
        <vs-popup
            :active.sync="popupAbrirIngresarGuia"
            title="Ingresar Guía"
            class="popopPadre"
            :fullscreen="Number(onlyVisualizar) === 1"
            >
            <p v-if="ObjectedSelected.remi_guia_remision"><b>Guia de remision</b>: {{ ObjectedSelected.remi_guia_remision }}</p>
            <div v-if="popupAbrirIngresarGuia">
                <EmpacadoIngresoGuiaVue
                :ObjectedSelected="ObjectedSelected"
                @changeGuia="changeGuia"
                :onlyVisualizar="onlyVisualizar"
                />
            </div>
        </vs-popup>
        <!--MODAL PARA MOSTRAR HOJA DIARIA-->
        <vs-popup fullscreen v-if="popupReporteDespachoCALMED" :active.sync="popupReporteDespachoCALMED" class="popopPadre" title="Reporte">
            <div v-if="popupReporteDespachoCALMED">
                <vs-row class=" border rounded-md">
                    <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                        <div class="flex justify-center">
                            <b class="mr-3">Reporte con guias de remision </b>
                            <vs-switch color="success" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="conguia">
                                <span slot="on">SI</span>
                                <span slot="off">NO</span>
                            </vs-switch>
                        </div>
                    </vs-col>
                </vs-row>
                <br>
                <div align="center" class="mb-3">
                    <!-- Parametros Imprimir: 1.-Tamaño general del texto, 2.- Nombre del archivo, 3.- Tamaño del borde td, 4.- Nombre Marca Agua-->
                    <vs-button @click="m_imprimirTodos('12px',`reporte_${ObjectedDocument.remi_num_factura}_diarioDespacho'}`,'0px','')">Imprimir</vs-button>
                </div>
                <br>
                <vx-card id="seccionImprimir2">
                    <exportDespachoCALMEDVue :datos="ObjectedDocument" :conguia="conguia" />
                </vx-card>
            </div>
        </vs-popup>
        <!--MODAL PARA VERIFICAR PEDIDO EN PERSEO-->
        <vs-popup fullscreen :title="'Verificar Pedido en Perseo: ' + (ObjectedSelected.ven_codigo || '')" :active.sync="popupVerificarPerseo" class="popopPadre">
            <div v-if="popupVerificarPerseo">
                <div class="mb-4">
                    <vs-button @click="cerrarVerificacionPerseo" color="danger" type="border">
                        <i class="fa-solid fa-times"></i> Cerrar
                    </vs-button>
                </div>

                <!-- Loading Pedido -->
                <div v-if="loadingPerseo" class="text-center p-4">
                    <vs-progress indeterminate color="primary"></vs-progress>
                    <p class="mt-3">Consultando pedido en Perseo...</p>
                </div>

                <!-- Contenido cuando hay datos -->
                <div v-else-if="dataPerseo">
                    <!-- Información de la Venta -->
                    <vx-card class="mb-4">
                        <h4 class="mb-3"><i class="fa-solid fa-info-circle"></i> Información de la Venta</h4>
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <strong>Código de Venta:</strong> {{ dataPerseo.venta_info.ven_codigo }}
                            </div>
                            <div>
                                <strong>ID Pedido Perseo:</strong> {{ dataPerseo.venta_info.id_pedido_perseo }}
                            </div>
                            <div>
                                <strong>Código Pedido:</strong> {{ dataPerseo.venta_info.pedido_codigo }}
                            </div>
                            <!-- <div>
                                <strong>Fecha Envío:</strong> {{ fechaLarga(dataPerseo.venta_info.fecha_envio_perseo) }}
                            </div> -->
                            <div v-if="dataPerseo.venta_info.id_factura_perseo">
                                <strong>ID Factura Perseo:</strong>
                                <vs-chip color="success">{{ dataPerseo.venta_info.id_factura_perseo }}</vs-chip>
                            </div>
                            <div v-if="dataPerseo.venta_info.factura_perseo">
                                <strong>Factura:</strong>
                                <vs-chip color="success">{{ dataPerseo.venta_info.factura_perseo }}</vs-chip>
                            </div>
                        </div>
                    </vx-card>

                    <!-- Información del Pedido -->
                    <vx-card v-if="dataPerseo.data && dataPerseo.data.pedidos && dataPerseo.data.pedidos.length > 0" class="mb-4">
                        <h4 class="mb-3"><i class="fa-solid fa-receipt"></i> Información del Pedido</h4>
                        <div class="grid grid-cols-3 gap-4">
                            <div>
                                <strong>Cliente:</strong> {{ dataPerseo.data.pedidos[0].cliente }}
                            </div>
                            <div>
                                <strong>Estado:</strong>
                                <vs-chip :color="getEstadoPedidoColor(dataPerseo.data.pedidos[0].estado)">
                                    {{ getEstadoPedidoTexto(dataPerseo.data.pedidos[0].estado) }}
                                </vs-chip>
                            </div>
                            <div>
                                <strong>Total:</strong> ${{ Number(dataPerseo.data.pedidos[0].total || 0).toFixed(2) }}
                            </div>
                            <div>
                                <strong>Emisión:</strong> {{ formatearFecha(dataPerseo.data.pedidos[0].emision) }}
                            </div>
                            <div>
                                <strong>Almacén:</strong> {{ dataPerseo.data.pedidos[0].almacen }}
                            </div>
                            <div>
                                <strong>Forma de Pago:</strong> {{ dataPerseo.data.pedidos[0].forma_pago }}
                            </div>
                        </div>

                        <!-- Banner: Pedido aún no facturado -->
                        <div v-if="dataPerseo.data.pedidos[0].estado != 3" class="mt-4 p-3 bg-yellow-100 border border-yellow-300 rounded">
                            <i class="fa-solid fa-clock text-warning"></i>
                            <strong class="text-warning ml-2">Pedido aún no facturado</strong>
                            <p class="text-sm mt-2">Este pedido se encuentra en estado: <b>{{ getEstadoPedidoTexto(dataPerseo.data.pedidos[0].estado) }}</b></p>
                        </div>

                        <!-- Detalles del Pedido (tabla de productos - colapsable) -->
                        <div v-if="dataPerseo.data.pedidos[0].detalles && dataPerseo.data.pedidos[0].detalles.length > 0" class="mt-4">
                            <vs-collapse accordion>
                                <vs-collapse-item>
                                    <div slot="header" class="flex items-center gap-2">
                                        <i class="fa-solid fa-list"></i>
                                        <strong>Detalles del Pedido ({{ dataPerseo.data.pedidos[0].detalles.length }} productos)</strong>
                                    </div>
                                    <div class="overflow-auto" style="max-height: 400px;">
                                        <table class="w-full border">
                                            <thead class="bg-gray-200 sticky top-0">
                                                <tr>
                                                    <th class="p-2 border text-left">Código</th>
                                                    <th class="p-2 border text-left">Producto</th>
                                                    <th class="p-2 border text-center">Cantidad</th>
                                                    <th class="p-2 border text-right">Precio</th>
                                                    <th class="p-2 border text-right">Descuento</th>
                                                    <th class="p-2 border text-right">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(detalle, index) in dataPerseo.data.pedidos[0].detalles" :key="index">
                                                    <td class="p-2 border">{{ detalle.productocodigo }}</td>
                                                    <td class="p-2 border">{{ detalle.nombreproducto }}</td>
                                                    <td class="p-2 border text-center">{{ detalle.cantidad }}</td>
                                                    <td class="p-2 border text-right">${{ Number(detalle.precio || 0).toFixed(2) }}</td>
                                                    <td class="p-2 border text-right">{{ detalle.descuento }}%</td>
                                                    <td class="p-2 border text-right font-bold">
                                                        ${{ ((detalle.cantidad * detalle.precio) - ((detalle.cantidad * detalle.precio * detalle.descuento) / 100)).toFixed(2) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </vs-collapse-item>
                            </vs-collapse>
                        </div>
                    </vx-card>

                    <!-- Loading Factura -->
                    <vx-card v-if="loadingFactura" class="mb-4">
                        <div class="text-center p-4">
                            <vs-progress indeterminate color="success"></vs-progress>
                            <p class="mt-3">Verificando factura en Perseo...</p>
                        </div>
                    </vx-card>

                    <!-- Información de la Factura cuando se encuentra -->
                    <vx-card v-else-if="dataFactura && dataFactura.factura_encontrada" class="mb-4">
                        <div class="p-3 bg-green-100 border border-green-300 rounded mb-4">
                            <i class="fa-solid fa-check-circle text-success"></i>
                            <strong class="text-success ml-2">Factura vinculada exitosamente</strong>
                            <p class="text-sm mt-2">El pedido está facturado y se ha guardado la información en el sistema.</p>
                        </div>

                        <h4 class="mb-3"><i class="fa-solid fa-file-invoice"></i> Información de la Factura</h4>
                        <div class="grid grid-cols-3 gap-4" v-if="dataFactura.factura_info && dataFactura.factura_info.factura_completa">
                            <div>
                                <strong>Número:</strong> {{ dataFactura.factura_info.factura_perseo }}
                            </div>
                            <div>
                                <strong>Emisión:</strong> {{ formatearFecha(dataFactura.factura_info.factura_completa.emision) }}
                            </div>
                            <div>
                                <strong>Total:</strong> ${{ Number(dataFactura.factura_info.factura_completa.total || 0).toFixed(2) }}
                            </div>
                            <div>
                                <strong>Cliente:</strong> {{ dataFactura.factura_info.factura_completa.cliente }}
                            </div>
                            <div>
                                <strong>RUC/CI:</strong> {{ dataFactura.factura_info.factura_completa.ci_ruc }}
                            </div>
                            <div>
                                <strong>Forma de Pago:</strong> {{ dataFactura.factura_info.factura_completa.forma_pago }}
                            </div>
                            <div class="col-span-3" v-if="dataFactura.factura_info.factura_completa.claveacceso">
                                <strong>Clave Acceso:</strong>
                                <code class="bg-gray-100 p-1 rounded text-xs">{{ dataFactura.factura_info.factura_completa.claveacceso }}</code>
                            </div>
                        </div>

                        <!-- Detalles de la Factura (tabla de productos - colapsable) -->
                        <div v-if="dataFactura.factura_info.factura_completa.facturasd && dataFactura.factura_info.factura_completa.facturasd.detalles && dataFactura.factura_info.factura_completa.facturasd.detalles.length > 0" class="mt-4">
                            <vs-collapse accordion>
                                <vs-collapse-item>
                                    <div slot="header" class="flex items-center gap-2">
                                        <i class="fa-solid fa-list"></i>
                                        <strong>Detalles de la Factura ({{ dataFactura.factura_info.factura_completa.facturasd.detalles.length }} productos)</strong>
                                    </div>
                                    <div class="overflow-auto" style="max-height: 400px;">
                                        <table class="w-full border">
                                            <thead class="bg-gray-200 sticky top-0">
                                                <tr>
                                                    <th class="p-2 border text-left">Código</th>
                                                    <th class="p-2 border text-left">Producto</th>
                                                    <th class="p-2 border text-center">Cantidad</th>
                                                    <th class="p-2 border text-right">Precio</th>
                                                    <th class="p-2 border text-right">Descuento</th>
                                                    <th class="p-2 border text-right">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(detalle, index) in dataFactura.factura_info.factura_completa.facturasd.detalles" :key="index">
                                                    <td class="p-2 border">{{ detalle.productocodigo }}</td>
                                                    <td class="p-2 border">{{ detalle.nombreproducto }}</td>
                                                    <td class="p-2 border text-center">{{ detalle.cantidad }}</td>
                                                    <td class="p-2 border text-right">${{ Number(detalle.precio || 0).toFixed(2) }}</td>
                                                    <td class="p-2 border text-right">{{ detalle.descuento }}%</td>
                                                    <td class="p-2 border text-right font-bold">
                                                        ${{ ((detalle.cantidad * detalle.precio) - ((detalle.cantidad * detalle.precio * detalle.descuento) / 100)).toFixed(2) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </vs-collapse-item>
                            </vs-collapse>
                        </div>
                    </vx-card>

                    <!-- Banner: No se encontró coincidencia en factura -->
                    <vx-card v-else-if="dataFactura && !dataFactura.factura_encontrada" class="mb-4">
                        <div class="p-3 bg-yellow-100 border border-yellow-300 rounded">
                            <i class="fa-solid fa-exclamation-triangle text-warning"></i>
                            <strong class="text-warning ml-2">No se encontró una factura que coincida</strong>
                            <p class="text-sm mt-2">{{ dataFactura.message || 'El pedido está facturado pero no se encontró una factura con los mismos productos y cantidades.' }}</p>
                        </div>
                    </vx-card>

                    <!-- JSON Pedido (solo visible para admin: id_group = 1) -->
                    <vx-card v-if="dataPerseo.data && usuario.id_group == 1" class="mb-4">
                        <div class="flex justify-between items-center mb-3">
                            <h4><i class="fa-solid fa-code"></i> Datos del Pedido (JSON)</h4>
                            <vs-button
                                size="small"
                                :icon="mostrarJSON ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                                @click="mostrarJSON = !mostrarJSON"
                                type="border"
                            >
                                {{ mostrarJSON ? 'Ocultar' : 'Mostrar' }}
                            </vs-button>
                        </div>
                        <div v-show="mostrarJSON">
                            <pre class="bg-gray-100 p-4 rounded overflow-auto" style="max-height: 400px;">{{ JSON.stringify(dataPerseo.data, null, 2) }}</pre>
                        </div>
                    </vx-card>

                    <!-- JSON Factura (solo visible para admin: id_group = 1) -->
                    <vx-card v-if="dataFactura && (dataFactura.factura_encontrada || dataFactura.facturas_completo) && usuario.id_group == 1" class="mb-4">
                        <div class="flex justify-between items-center mb-3">
                            <h4><i class="fa-solid fa-code"></i> Datos de la Factura (JSON)</h4>
                            <vs-button
                                size="small"
                                :icon="mostrarJSONFactura ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                                @click="mostrarJSONFactura = !mostrarJSONFactura"
                                type="border"
                            >
                                {{ mostrarJSONFactura ? 'Ocultar' : 'Mostrar' }}
                            </vs-button>
                        </div>
                        <div v-show="mostrarJSONFactura">
                            <pre class="bg-gray-100 p-4 rounded overflow-auto" style="max-height: 400px;">{{ JSON.stringify(dataFactura, null, 2) }}</pre>
                        </div>
                    </vx-card>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div v-else class="text-center p-4">
                    <i class="fa-solid fa-exclamation-triangle text-warning" style="font-size: 48px;"></i>
                    <p class="mt-3">No hay datos para mostrar</p>
                </div>
            </div>
        </vs-popup>
    </div>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import Vue from "vue";
import axios from "axios";
import vSelect from "vue-select";
import Generalmix from "../../../../../mixins/Generalmix";
import imprimirMixin from "@/mixins/Pedidosmix";
const EmpacarCrearVue       = () => import('@/views/home/bodega/components/Empacar/EmpacarCrear.vue');
const RegresarAPendiente    = () => import("@/views/bodega/codigos/components/Regresar_A_Pendiente.vue");
const EmpacarEditVue        = () => import('@/views/home/bodega/components/Empacar/Empacaredit.vue');
const EmpacadoIngresoGuiaVue = () => import("./EmpacadoIngresoGuia.vue");
const exportDespachoCALMEDVue = () => import('@/views/facturacion/10_10_1_4/bodegas/Reportes/exportDespachoCALMED');
const PerseoTablaAvanzada = () => import('@/views/perseo/components/perseo_tabla_avanzada.vue');
const ReporteVentasPDF = () => import('@/views/pedidos/facturacion/imprimir/ReporteVentasPDF.vue');
export default {
    mixins: [Generalmix,imprimirMixin],
    components: {
        "v-select": vSelect,
        EmpacarCrearVue,
        RegresarAPendiente,
        EmpacarEditVue,
        EmpacadoIngresoGuiaVue,
        exportDespachoCALMEDVue,
        PerseoTablaAvanzada,
        ReporteVentasPDF,
    },
    data() {
        return {
            usuario:[],
            Ventas: [],
            ventasFiltradas: [],
            DetalleVenta: [],
            userVentas: [],
            popupActivoGuardar: false,
            popupActivoEditar: false,
            popupActivoDesactivar: false,
            popupActivoEliminar: false,
            tabVentas: {
                ven_codigo: "",
                bod_responsable: "",
                bod_nombre: "",
                bod_ubicacion: "",
                bod_estado: "",
                created_at: "",
                opcion: '',
            },
            ven_codigo: 0,
            valorBusqueda: "0",
            Bodega_inactivos: [],
            busquedaxcodigo: "",
            checkBox_mostrarinactivos: false,
            contadorpendientes: 0,
            menu: 0,
            datos: [],
            ObjectedSelected:'',
            popupDespachar:false,
            popupRegresarAPendiente:false,
            popupAbrirEmpacadoEditar:false,
            ObjectedDocument:'',
            contadorExcluidos:0,
            months: [
                { name: 'Enero', value: 1 },
                { name: 'Febrero', value: 2 },
                { name: 'Marzo', value: 3 },
                { name: 'Abril', value: 4 },
                { name: 'Mayo', value: 5 },
                { name: 'Junio', value: 6 },
                { name: 'Julio', value: 7 },
                { name: 'Agosto', value: 8 },
                { name: 'Septiembre', value: 9 },
                { name: 'Octubre', value: 10 },
                { name: 'Noviembre', value: 11 },
                { name: 'Diciembre', value: 12 }
            ],
            years: Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i),
            yearSelect: new Date().getFullYear(),
            mesSelect: new Date().getMonth() + 1,
            popupAbrirIngresarGuia:false,
            popupReporteDespachoCALMED:false,
            onlyVisualizar:0,
            conguia: false,
            sinFecha:true,
            fechaDesde: '',
            fechaHasta: '',
            filtroEstado: '2',
            filtroFechasActivo: false,
            soloEnviadoPerseo: 1,
            opcionesEstado: [
                { label: 'Todos', value: 'todos' },
                { label: 'Pendientes', value: '2' },
                { label: 'Despachadas', value: '1' }
            ],
            resumenVentas: null,
            columnasTabla: [
                {
                    label: 'Código',
                    field: 'ven_codigo',
                    width: '250px',
                    sortable: true,
                    filtrable: true
                },
                {
                    label: 'Cliente Perseo',
                    field: 'ven_cliente',
                    sortable: true,
                    filtrable: true
                },
                {
                    label: 'Estado Venta',
                    field: 'estado_nombre',
                    width: '140px',
                    sortable: true,
                    filtrable: true
                },
                {
                    label: 'Factura Perseo',
                    field: 'factura_perseo',
                    width: '180px',
                    sortable: true,
                    filtrable: true
                }
            ],
            popupVerificarPerseo: false,
            dataPerseo: null,
            loadingPerseo: false,
            mostrarJSON: false,
            dataFactura: null,
            loadingFactura: false,
            mostrarJSONFactura: false,
            facturaVinculada: false,
            popupPDFVenta: false,
            ventaSeleccionadaPDF: null,
            id: '',
            opcion: 0,
        };
    },
    mounted() {
        let me = this
        this.menu = 0;
        this.usuario = JSON.parse(localStorage.getItem('usuario'));
        this.inicializarFechas();
        this.cargarVentasPerseo();
    },
    computed: {
      ...mapState(['userRoot','userFacturador','userAdminFacturador']),
    },
    watch: {
        popupVerificarPerseo(newVal, oldVal) {
            // Cuando el popup se cierra (de cualquier forma)
            if (oldVal === true && newVal === false) {
                // Si se vinculó una factura, recargar el listado
                if (this.facturaVinculada) {
                    this.$f_notificacion('Actualizando listado...', 'primary', 'icon-refresh-cw', 1000);
                    setTimeout(() => {
                        this.cargarVentasPerseo();
                    }, 500);
                }
            }
        }
    },
    methods: {
        inicializarFechas() {
            const hoy = new Date();
            const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
            this.fechaDesde = primerDiaMes.toISOString().split('T')[0];
            this.fechaHasta = hoy.toISOString().split('T')[0];
        },
        cargarVentasPerseo() {
            let me = this;
            me.$vs.loading();

            let params = [];
            if (me.filtroEstado && me.filtroEstado !== 'todos') {
                params.push('estado=' + me.filtroEstado);
            }
            if (me.filtroFechasActivo && me.fechaDesde) {
                params.push('fecha_desde=' + me.fechaDesde);
            }
            if (me.filtroFechasActivo && me.fechaHasta) {
                params.push('fecha_hasta=' + me.fechaHasta);
            }
            params.push('solo_enviado_perseo=' + me.soloEnviadoPerseo);

            let url = 'api/perseo/ventas/por-despachar';
            if (params.length > 0) {
                url += '?' + params.join('&');
            }

            this.$http.get(this.$server_url + url)
                .then(res => {
                    if (res.data.status === 200) {
                        me.Ventas = res.data.data || [];
                        me.ventasFiltradas = [...me.Ventas];
                        me.resumenVentas = res.data.resumen || null;
                        me.$vs.loading.close();

                        if (me.Ventas.length === 0) {
                            me.$f_notificacion('No hay ventas para mostrar', 'warning', 'icon-alert-triangle');
                        } else {
                            me.$f_notificacion(`${me.Ventas.length} ventas cargadas correctamente`, 'success', 'icon-check');
                        }
                    } else {
                        me.$vs.loading.close();
                        me.$f_notificacion('Error al cargar ventas', 'danger', 'icon-x');
                    }
                })
                .catch(err => {
                    me.$vs.loading.close();
                    me.$f_notificacion('Error al conectar con el servidor', 'danger', 'icon-x');
                });
        },
        filtrarPorFecha() {
            let me = this;
            if (!me.fechaDesde || !me.fechaHasta) {
                me.$f_notificacion('Debe seleccionar ambas fechas', 'warning', 'icon-alert-triangle');
                return;
            }
            const desde = new Date(me.fechaDesde);
            const hasta = new Date(me.fechaHasta);
            if (desde > hasta) {
                me.$f_notificacion('La fecha desde no puede ser mayor a la fecha hasta', 'warning', 'icon-alert-triangle');
                return;
            }
            // Consulta al backend con las fechas
            me.cargarVentasPerseo();
        },
        limpiarFiltroFechas() {
            this.filtroFechasActivo = false;
            this.fechaDesde = '';
            this.fechaHasta = '';
            // Recarga sin filtro de fechas
            this.cargarVentasPerseo();
            this.$f_notificacion('Filtro de fechas eliminado', 'primary', 'icon-check');
        },
        limpiarFiltros() {
            this.inicializarFechas();
            this.ventasFiltradas = [...this.Ventas];
            this.$f_notificacion('Filtros limpiados', 'primary', 'icon-check');
        },
        verPDFVenta(venta) {
            this.ventaSeleccionadaPDF = venta;
            this.popupPDFVenta = true;
        },
        changePendiente(e){
            let me = this
            if (e.verificacionemitsaveandedit == 1) {
                me.popupRegresarAPendiente = false;
                this.verificarseleccion();
            } else if (e.verificacionemitsaveandedit == 2) {
                me.popupRegresarAPendiente = false;
            } else {
            }
        },
        f_despachar() {
            let me = this;
            let datos = {
                ven_codigo: this.ObjectedSelected.ven_codigo,
                est_ven_codigo: 1,
                id_empresa: this.ObjectedSelected.id_empresa,
                user_despacha:this.usuario.idusuario
            };
            me.$vs.loading();
            this.$http
                .post(this.$server_url + "Desactivar_venta", datos)
                .then((res) => {
                    me.$vs.loading.close();
                    if(res.data.status == 0){
                        me.$vs.notify({
                            text: res.data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle',
                            time:3000
                        })
                        this.verificarseleccion();
                        return
                    }
                    this.verificarseleccion();
                    me.$vs.notify({
                        text: "Despacho exitoso",
                        color: "success",
                        iconPack: "feather",
                        icon: "icon-check",
                    });
                    this.popupDespachar = false;
                })
                .catch((error) => {
                    console.log(error);
                    me.$vs.loading.close();
                    me.$vs.notify({
                        text: "No se pudo despachar",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-x",
                    });
                });

        },
        change(e) {
            this.popupAbrirEmpacadoEditar = false;
            if (e == true) {
                this.cargarVentasPerseo();
            }
        },
        changen(e) {
            if (e == true) {
                this.menu = 0;
                this.verificarseleccion();
            }
        },
        f_empaca(tr) {
            //si es pre factura y tiene un doc_intercambio seguir con el proceso
            if(tr.idtipodoc == 1){}
            else{
                //si doc_intercambio no es null mostrar no se puede empacar
                if (tr.doc_intercambio) {
                    this.$vs.notify({
                    text: "Este documento esta movido no es posible empacar",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-x",
                    });
                    return;
                }
            }

            this.id = tr.ven_codigo;
            if (tr.est_ven_codigo == 2 || tr.est_ven_codigo == 12 || tr.est_ven_codigo == 10 || tr.est_ven_codigo == 1) {
                this.menu = 1;
                this.opcion = 0;
                //est_ven_codigo ; 1 = despachado ; 2 => pendiente; 10 => Empacado; 11 => Excluir; 12 => preparado;  1 => aprobado finalizado o despachado
            } else if (tr.est_ven_codigo == 11) {
                this.menu = 1;
                this.opcion = 1;
            }
        },
        f_editarExcluidos(){
            let me = this;
            this.$http.get(this.$server_url+`empaqueBodega?pendientes=1&individual=${this.ObjectedSelected.ven_codigo}`)
            .then(function (res) {
               if(res.data.length == 0){
                   me.m_message("No se encontraron empaques pendientes excluidos para este documento","warning","icon-alert-triangle")
                   return
               }
               me.ObjectedDocument = res.data[0]
               me.popupAbrirEmpacadoEditar = true
            })
            .catch(function (error) {
                console.log(error + ' error');
            })
        },
        verificarseleccion() {
            let me = this;
            this.Ventas = [];
            this.popupRegresarAPendiente = false;
            this.contadorExcluidos = 0;
            this.Ventas = [];
            if(!this.sinFecha){
              //validacion mes
              if(me.mesSelect == "" || me.mesSelect == "" || me.mesSelect == undefined){
                  me.m_message("Debe seleccionar un mes","warning","icon-alert-triangle")
                  return
              }
              //validacion mes
              if(me.mesSelect < 1 || me.mesSelect > 12){
                  me.m_message("Ingrese un mes valido","warning","icon-alert-triangle")
                  return
              }
              //validacion año
              if(me.yearSelect < 1900 || me.yearSelect > new Date().getFullYear()){
                  me.m_message("Ingrese un año valido","warning","icon-alert-triangle")
                  return
              }
              //validacion año
              if(me.yearSelect == "" || me.yearSelect == "" || me.yearSelect == undefined){
                  me.m_message("Debe seleccionar un año","warning","icon-alert-triangle")
                  return
              }
            }

                //pendientes
            if (this.valorBusqueda === '0') {
                this.getVentasPendientes(0);
                //excluidos
            } else if (this.valorBusqueda === '1') {
                this.getVentasPendientes(1);
            } else if (this.valorBusqueda === '2') {
                this.getVentasPendientes(2);
            } else if (this.valorBusqueda === '3') {
                this.getVentasPendientes(3);
            }
            //despachados
            else if (this.valorBusqueda === '4') {
                this.getVentasPendientes(4);
            }
            //excluidos contador
            this.getContadorExcluidos()
        },
        getContadorExcluidos(){
            let me = this;
            this.contadorExcluidos = 0;
            this.$http.get(this.$server_url + `GetVentasPendientes?op=1&contarArray=1&anio=${me.yearSelect}&mes=${me.mesSelect}`)
            .then(res => {
                this.contadorExcluidos = res.data;
            })
            .catch(err => {
                console.log(err)
                me.$vs.loading.close()
                me.$vs.notify({
                    text: 'No se pudo obtener el contador de excluidos',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-x'
                })
            })
        },
        getVentasPendientes(op) {
            let me = this;
            this.contadorpendientes = 1;
            this.busquedaxcodigo    = '';
            let url = ''
            if(me.sinFecha == false){
              url = `GetVentasPendientes?op=${op}&anio=${me.yearSelect}&mes=${me.mesSelect}`
            }
            if(me.sinFecha){
              url = `GetVentasPendientes?op=${op}&sinfecha=1`
            }
            me.$vs.loading()
            this.$http.get(this.$server_url + url)
                .then(res => {
                    this.Ventas = res.data;
                    me.$vs.loading.close()
                    if (me.Ventas.length == 0) {
                        me.$vs.notify({
                            text: 'No hay ventas pendientes por despachar',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        })
                    }
                })
                .catch(err => {
                    console.log(err)
                    me.$vs.loading.close()
                    me.$vs.notify({
                        text: 'No se pudo obtener los documentos',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-x'
                    })
                })
        },
        getVentaDespachadasxParametro() {
            let me = this;
            if (me.busquedaxcodigo.length < 2) {
                me.$vs.notify({
                    text: "Minimo 2 caracteres de busqueda",
                    color: "warning",
                    iconPack: "feather",
                    icon: "icon-check",
                });
                return false;
            }
            me.$vs.loading();
            this.$http.get(this.$server_url + "GetVentasDespachadasxParametro?opcion=0&parte_documento=" + me.busquedaxcodigo)
                .then(function (res) {
                    me.Ventas = res.data;
                    if (me.Ventas.length === 0) {
                        me.$vs.notify({
                            text: "No hay Ventas para esta búsqueda",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-x",
                        });
                        me.Ventas = [];
                        me.getUserBodega();
                        me.$vs.loading.close();
                    } else {
                        // me.filtroRegion();
                        me.$vs.loading.close();
                        if (res.data.message) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: "success",
                                iconPack: "feather",
                                icon: "icon-user",
                            });
                        }
                    }
                })
                .catch(function (error) {
                    if (error.response && error.response.status === 404) {
                        me.$vs.notify({
                            text: "No hay Ventas para esta búsqueda",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-x",
                        });
                        me.Ventas = [];
                        me.$vs.loading.close();
                    } else {
                        console.log(error + " error");
                        me.$vs.loading.close();
                    }
                });
        },
        //METODOS PARA EL EMPACADO
        openConfirmAnularEmpacado() {
            let me = this;
            let datoEmpacado = me.ObjectedSelected.empacado
            if(datoEmpacado.length == 0){
                me.m_message("No hay documentos empacados","warning","icon-alert-triangle")
                return
            }
            console.log("datoEmpacado",me.ObjectedSelected)
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Anular Empaque`,
                text: '¿Está seguro de anular el empaque #' + datoEmpacado[0].remi_codigo + '?'+' Al hacerlo se regresara a pendientes de despacho',
                accept: this.f_anularEmpacado,
                acceptText: 'Si, deseo anular el empacado',
                cancelText: 'Cancelar',
            })
        },
        f_anularEmpacado() {
            let me = this;
            let datoEmpacado                    = me.ObjectedSelected.empacado
            let formData = new FormData();
            formData.append('id',               datoEmpacado[0].id_remision);
            formData.append('remi_idempresa',   me.ObjectedSelected.id_empresa);
            formData.append('anulaEmpaque',     '1');
            formData.append('factura',          me.ObjectedSelected.ven_codigo);
            formData.append('user_created',     me.usuario.idusuario);
            me.$vs.loading();
            this.$http.post(this.$server_url + 'empaqueBodega', formData)
            .then(res => {
                me.$vs.loading.close();
                if(res.data.status == 0){
                    me.$vs.notify({
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-x'
                    });
                    return
                }
                me.$vs.notify({
                    text: res.data.message,
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                });
                this.verificarseleccion();
            })
            .catch(e => {
                console.log("error",e)
                me.$vs.loading.close();
                me.$vs.notify({
                    text: 'No se pudo anular el empaque',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check'
                });
            });
        },
        changeGuia(e){
            let me = this
            if(e == false){
                me.popupAbrirIngresarGuia = false
            }else{
                me.popupAbrirIngresarGuia = false
                //ejecutar despues de 1 segundo
                setTimeout(function(){
                    me.verificarseleccion();
                },1000)
            }
        },
        realizarReporteHojaDiaria(){
            let me = this;
            this.$http.get(this.$server_url+`GetRemisionCALMED_FECHA?op=1&individual=${this.ObjectedSelected.ven_codigo}`)
            .then(function (res) {
               if(res.data.length == 0){
                   me.m_message("No se encontraron empaques pendientes excluidos para este documento","warning","icon-alert-triangle")
                   return
               }
               me.ObjectedDocument = res.data
               me.popupReporteDespachoCALMED = true;
            })
            .catch(function (error) {
                console.log(error + ' error');
            })
        },
        verificarPedidoPerseo(venta) {
            let me = this;

            if (!venta.estadoPerseo || venta.estadoPerseo != 1) {
                me.$f_notificacion('Esta venta no ha sido enviada a Perseo', 'warning', 'icon-alert-triangle');
                return;
            }

            me.popupVerificarPerseo = true;
            me.loadingPerseo = true;
            me.dataPerseo = null;
            me.dataFactura = null;
            me.mostrarJSON = false;
            me.mostrarJSONFactura = false;
            me.facturaVinculada = false;

            let datos = {
                ven_codigo: venta.ven_codigo,
                empresa: venta.id_empresa
            };

            // Primera llamada: consultar solo el pedido (más rápida)
            this.$http.post(this.$server_url + 'api/perseo/ventas/pedidos-consulta', datos)
                .then(res => {
                    me.loadingPerseo = false;

                    if (res.data.status === 200) {
                        me.dataPerseo = res.data;
                        me.$f_notificacion('Pedido consultado exitosamente', 'success', 'icon-check', 2000);

                        // Si el pedido está facturado (estado=3), consultar automáticamente la factura
                        if (res.data.data && res.data.data.pedidos && res.data.data.pedidos.length > 0) {
                            const pedido = res.data.data.pedidos[0];
                            if (pedido.estado == 3) {
                                me.verificarFactura(venta);
                            }
                        }
                    } else {
                        me.$f_notificacion(res.data.message || 'Error al consultar pedido', 'danger', 'icon-x');
                        me.popupVerificarPerseo = false;
                    }
                })
                .catch(err => {
                    me.loadingPerseo = false;
                    console.error('Error al verificar pedido en Perseo:', err);

                    let mensaje = 'Error al conectar con Perseo';
                    if (err.response && err.response.data && err.response.data.message) {
                        mensaje = err.response.data.message;
                    }

                    me.$f_notificacion(mensaje, 'danger', 'icon-x');
                    me.popupVerificarPerseo = false;
                });
        },
        verificarFactura(venta) {
            let me = this;

            me.loadingFactura = true;

            let datos = {
                ven_codigo: venta.ven_codigo,
                empresa: venta.id_empresa
            };

            // Segunda llamada: verificar y enlazar factura (más lenta)
            this.$http.post(this.$server_url + 'api/perseo/ventas/facturas-verificar', datos)
                .then(res => {
                    me.loadingFactura = false;

                    if (res.data.status === 200) {
                        me.dataFactura = res.data;

                        if (res.data.factura_encontrada) {
                            me.facturaVinculada = true;
                            me.$f_notificacion('Factura vinculada exitosamente', 'success', 'icon-check', 3000);

                            // Actualizar el registro en el listado
                            const index = me.ventasFiltradas.findIndex(v => v.ven_codigo === venta.ven_codigo);
                            if (index !== -1) {
                                me.$set(me.ventasFiltradas[index], 'factura_perseo', res.data.factura_info.factura_perseo);
                                me.$set(me.ventasFiltradas[index], 'id_factura_perseo', res.data.factura_info.id_factura_perseo);
                            }
                        } else {
                            me.$f_notificacion('No se encontró una factura que coincida con el pedido', 'warning', 'icon-alert-triangle', 4000);
                        }
                    } else {
                        me.$f_notificacion(res.data.message || 'Error al verificar factura', 'warning', 'icon-alert-triangle');
                    }
                })
                .catch(err => {
                    me.loadingFactura = false;
                    console.error('Error al verificar factura:', err);

                    let mensaje = 'Error al verificar factura';
                    if (err.response && err.response.data && err.response.data.message) {
                        mensaje = err.response.data.message;
                    }

                    me.$f_notificacion(mensaje, 'warning', 'icon-alert-triangle');
                });
        },
        cerrarVerificacionPerseo() {
            let me = this;
            me.popupVerificarPerseo = false;

            // Si se vinculó una factura, recargar el listado
            if (me.facturaVinculada) {
                me.$f_notificacion('Actualizando listado...', 'primary', 'icon-refresh-cw', 1000);
                setTimeout(() => {
                    me.cargarVentasPerseo();
                }, 500);
            }
        },
        marcarComoDespachadoPerseo(venta) {
            let me = this;

            const requiereFacturaPerseo = venta.estadoPerseo == 1;

            if (requiereFacturaPerseo) {
                if (!venta.factura_perseo) {
                    me.$f_notificacion('Esta venta fue enviada a Perseo y no tiene factura vinculada', 'warning', 'icon-alert-triangle');
                    return;
                }
            }

            if (venta.est_ven_codigo != 2) {
                me.$f_notificacion('Esta venta no está en estado Pendiente', 'warning', 'icon-alert-triangle');
                return;
            }

            me.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: 'Marcar como Despachado',
                text: requiereFacturaPerseo
                    ? `¿Está seguro de marcar la venta ${venta.ven_codigo} como despachada?\n\nFactura Perseo: ${venta.factura_perseo}`
                    : `¿Está seguro de marcar el documento ${venta.ven_codigo} como despachado?`,
                accept: () => me.confirmarDespachadoPerseo(venta),
                acceptText: 'Sí, marcar como despachado',
                cancelText: 'Cancelar'
            });
        },
        confirmarDespachadoPerseo(venta) {
            let me = this;

            let datos = {
                ven_codigo: venta.ven_codigo,
                empresa: venta.id_empresa,
                usuario_id: me.usuario.idusuario
            };

            me.$vs.loading();

            this.$http.post(this.$server_url + 'api/perseo/ventas/marcar-despachado', datos)
                .then(res => {
                    me.$vs.loading.close();

                    if (res.data.status === 200) {
                        me.$f_notificacion('Venta marcada como despachada exitosamente', 'success', 'icon-check', 3000);

                        // Actualizar el registro en el listado
                        const index = me.ventasFiltradas.findIndex(v => v.ven_codigo === venta.ven_codigo);
                        if (index !== -1) {
                            me.$set(me.ventasFiltradas[index], 'est_ven_codigo', 1);
                            me.$set(me.ventasFiltradas[index], 'estado_nombre', 'Despachado');
                        }

                        // Recargar listado después de 1 segundo
                        setTimeout(() => {
                            me.cargarVentasPerseo();
                        }, 1000);
                    } else {
                        me.$f_notificacion(res.data.message || 'Error al marcar como despachado', 'danger', 'icon-x');
                    }
                })
                .catch(err => {
                    me.$vs.loading.close();

                    let mensaje = 'Error al marcar como despachado';
                    if (err.response && err.response.data && err.response.data.message) {
                        mensaje = err.response.data.message;
                    }

                    me.$f_notificacion(mensaje, 'danger', 'icon-x');
                });
        },
        getEstadoPedidoColor(estado) {
            if (estado == 0) return 'primary';
            if (estado == 1) return 'warning';
            if (estado == 2) return 'success';
            if (estado == 3) return 'success';
            return 'danger';
        },
        getEstadoPedidoTexto(estado) {
            if (estado == 0) return 'Pendiente';
            if (estado == 1) return 'En Proceso';
            if (estado == 2) return 'Despachado';
            if (estado == 3) return 'Facturado';
            return 'Desconocido';
        },
        formatearFecha(fecha) {
            if (!fecha) return '';
            if (fecha.length === 8) {
                const year = fecha.substring(0, 4);
                const month = fecha.substring(4, 6);
                const day = fecha.substring(6, 8);
                return `${day}/${month}/${year}`;
            }
            return fecha;
        },
    },
};
</script>
<style scoped>
.text {
  z-index: 9;
  background: var(--bg);
  color: var(--color);
  font-size:11px;
  padding: 1.5px;
  border-radius: 1px;
  height: fit-content;
  cursor: pointer;
  box-shadow: 0 4px 16px 4px rgba(0, 0, 0, 0.15);
}
.popopPadre {
    z-index: 51008;
    position: fixed;
}
.popup-pdf-venta {
    z-index: 51010 !important;
}
input[type="date"] {
    padding: 0.5rem 1rem;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    font-size: 0.9rem;
    transition: all 0.3s;
    background: white;
}
input[type="date"]:focus {
    outline: none;
    border-color: #1e3c72;
    box-shadow: 0 0 0 3px rgba(30, 60, 114, 0.1);
}
.text-primary {
    color: #1e3c72;
}
.text-success {
    color: #28C76F;
}
.text-gray-600 {
    color: #6c757d;
}
.font-semibold {
    font-weight: 600;
}
.gap-4 {
    gap: 1rem;
}
.gap-2 {
    gap: 0.5rem;
}
.v-select {
    min-width: 150px;
}
.vs-chip {
    display: inline-flex;
    align-items: center;
}
.vs-chip i {
    margin-right: 0.25rem;
}
.grid {
    display: grid;
}
.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
.col-span-3 {
    grid-column: span 3 / span 3;
}
.bg-green-100 {
    background-color: #d1fae5;
}
.border-green-300 {
    border-color: #86efac;
}
.bg-yellow-100 {
    background-color: #fef3c7;
}
.border-yellow-300 {
    border-color: #fcd34d;
}
.text-warning {
    color: #FF9F43;
}
.bg-gray-100 {
    background-color: #f3f4f6;
}
.bg-gray-200 {
    background-color: #e5e7eb;
}
.overflow-auto {
    overflow: auto;
}
.sticky {
    position: sticky;
}
.top-0 {
    top: 0;
}
code {
    font-family: monospace;
    font-size: 0.875rem;
}
.flex {
    display: flex;
}
.justify-between {
    justify-content: space-between;
}
.items-center {
    align-items: center;
}
table {
    border-collapse: collapse;
}
table thead tr {
    background-color: #f3f4f6;
}
table th, table td {
    padding: 0.5rem;
    border: 1px solid #e5e7eb;
}
/* ===== PANEL DE FILTROS DESPACHOS ===== */
.despachos-filtros-panel {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 14px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.filtros-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.filtros-separador {
    width: 1px;
    height: 24px;
    background: #cbd5e1;
    flex-shrink: 0;
}

.filtros-grupo {
    display: flex;
    align-items: center;
    gap: 6px;
}

.filtros-etiqueta {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
}

.filtros-input-fecha {
    padding: 4px 8px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    font-size: 12px;
    color: #334155;
    background: #f8fafc;
    outline: none;
    transition: border-color 0.2s;
}

.filtros-input-fecha:focus {
    border-color: #7c3aed;
    box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.1);
}

/* Estado Botones */
.filtros-estado-btns {
    display: flex;
    gap: 0;
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #cbd5e1;
}

.estado-btn {
    padding: 4px 12px;
    font-size: 11px;
    font-weight: 600;
    background: #f8fafc;
    color: #64748b;
    border: none;
    cursor: pointer;
    transition: all 0.15s ease;
    border-right: 1px solid #e2e8f0;
}

.estado-btn:last-child {
    border-right: none;
}

.estado-btn:hover {
    background: #e2e8f0;
    color: #334155;
}

.estado-btn-activo {
    color: #fff !important;
}

.estado-btn-todos.estado-btn-activo {
    background: #6366f1;
}

.estado-btn-pendiente.estado-btn-activo {
    background: #f59e0b;
}

.estado-btn-despachado.estado-btn-activo {
    background: #10b981;
}

/* Barra resumen (inline en fila 1) */
.resumen-item {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    font-weight: 500;
    color: #64748b;
    margin-left: 4px;
}

.resumen-item i {
    font-size: 10px;
}

.resumen-item b {
    font-weight: 700;
}

.resumen-total i { color: #6366f1; }
.resumen-total b { color: #4338ca; }

.resumen-pendientes i { color: #f59e0b; }
.resumen-pendientes b { color: #d97706; }

.resumen-despachadas i { color: #10b981; }
.resumen-despachadas b { color: #059669; }

/* ===== FILA 2: FILTRO FECHAS (FRONTEND) ===== */
.despachos-filtros-fechas {
    background: #fafbfd;
    border: 1px dashed #d1d5db;
    border-radius: 6px;
    padding: 7px 14px;
    margin-bottom: 12px;
}

.filtros-fechas-toggle {
    font-size: 11px;
    font-weight: 600;
    color: #7c3aed;
    background: #ede9fe;
    padding: 5px 12px;
    border-radius: 4px;
    border: 1px solid #c4b5fd;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
}

.filtros-fechas-toggle:hover {
    background: #ddd6fe;
    border-color: #a78bfa;
}

.filtros-fechas-toggle-activo {
    background: #7c3aed;
    color: #fff;
    border-color: #6d28d9;
}

.filtros-fechas-toggle-activo:hover {
    background: #6d28d9;
}

.filtros-fechas-resultado {
    font-size: 11px;
    color: #6366f1;
    font-weight: 500;
    margin-left: auto;
    white-space: nowrap;
}

.filtros-fechas-resultado b {
    font-weight: 700;
    color: #4338ca;
}

/* ===== RADIO ORIGEN ===== */
.filtros-radio-group {
    display: flex;
    gap: 10px;
}

.filtros-radio-label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    user-select: none;
}

.filtros-radio {
    accent-color: #7c3aed;
    cursor: pointer;
}
</style>
